export const relatoriosInitialState = {
  todasAsObrasRelatorio: [],
  todosOsFuncionariosRelatorio: [],

  // Relatórios
  relatorioMensalHoras: [],
  relatorioColaboradoresAtivos: [],
  relatorioVistaGeralDeProjeto: [],
};
